// extracted by mini-css-extract-plugin
export default {"link":"GD-z","disabled":"HD-z"};